import axios from 'axios'

const mailer = axios.create({
    baseURL: `${process.env.VUE_APP_URL_MAILER}`
});

export default mailer